import React from "react";
import { theme } from "twin.macro";
import { type Mode } from "~/features/ui/get-theme-style";
import { TRANSITION_DURATION } from "~/features/app/page-transition";

type Props = {
  mode: Mode;
  enabled?: boolean;
};

const style = {
  dark: theme`colors.black.100.light`,
  light: theme`colors.white.100.light`,
} as const;

export function useBodyBackground(props: Props) {
  const { mode, enabled = true } = props;

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    const timeoutId = setTimeout(() => {
      document.body.style.backgroundColor = style[mode];
    }, TRANSITION_DURATION * 1000);

    return () => clearTimeout(timeoutId);
  }, [enabled, mode]);
}
